module.exports = __webpack_public_path__ + "static/images/cover_C5.0eef174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C5.png
// module id = HYpx
// module chunks = 8